import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PublishLettersService } from 'src/app/services/publish-letters.service';

@Component({
  selector: 'app-secure-publish-letters-modal',
  templateUrl: './publish-letters-modal.component.html',
  styleUrls: ['./publish-letters-modal.component.scss']
})
export class PublishLettersModalComponent implements OnInit {
  isLoading: boolean = false;

  @Input() docType: {key: string, value: string};
  @Input() lotteryKey: number;
  @Input() lotteryCode: string;
  @Input() lotteryName: string;
  @Input() fileCount: number;

  publishFlag: boolean = false;
  publishedFlag: boolean = false;

  latestFileCount: number;

  constructor(private modalCtrl: ModalController, private publishLetterService: PublishLettersService) { }

  ngOnInit(): void { 
    this.latestFileCount = this.fileCount;
  }

  publishDocuments() {
    this.isLoading = true;
    this.publishLetterService
    .publishDocuments(this.lotteryKey, this.docType.key)
    .subscribe((data: any) => {
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.publishFlag = true;
        setTimeout(() => {
          this.fetchPublishStatus();
        }, 500);
      }
      else {
        this.publishLetterService.errorToast(data.errorMessage);
      }
    }, error => {
      this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    }); 
  }

  fetchPublishStatus() {
    this.publishLetterService
    .publishDocumentsFetchPublishStatus(this.lotteryKey, this.docType.key)
    .subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.latestFileCount = data.fileCount;

        if(this.latestFileCount > 0) {
          setTimeout(() => {
            this.fetchPublishStatus();
          }, 500);
        }
        else {
          this.publishedFlag = true;
        }
      }
      else {
        this.publishLetterService.errorToast(data.errorMessage);
      }
    }, error => {
      this.publishLetterService.errorToast(error.errorMessage||error.error.errorMessage);
    });
  }

  onCancel() {
    return this.modalCtrl.dismiss(null, 'close');
  }

}
